import { AppRouteGroup } from '#/routing/classes/AppRouteGroup';
import { routeGroup } from '#/routing/routes';

export const userDashboardRouteGroup = new AppRouteGroup('/dashboard');

export const userDashboardRootRedirect = userDashboardRouteGroup.rootRoute();

export const userDashboardSelectOrgRoute = routeGroup.route('select-org');

export const userDashboardSavedItemsRoute = userDashboardRouteGroup.route(
  'saved-items',
  ['tab', 'page'],
);

export const userDashboardViewEmploymentOnboardingRoute =
  userDashboardRouteGroup.route('employment-profile/:slug', ['applied']);

export const userDashboardListEventsRoute =
  userDashboardRouteGroup.route('events');

export const userDashboardCreateEventRoute =
  userDashboardRouteGroup.route('events/create');

export const userDashboardViewEventRoute =
  userDashboardRouteGroup.route('events/:eventId');

export const userDashboardPreviewEventRoute = userDashboardRouteGroup.route(
  'events/:eventId/preview',
);

export const userDashboardEditEventRoute = userDashboardRouteGroup.route(
  'events/:eventId/edit',
);

export const userDashboardProfileRoute =
  userDashboardRouteGroup.route('profile');

export const userDashboardProfessionalExperienceRoute =
  userDashboardRouteGroup.route('professional-experience');

export const userDashboardNotificationPreferencesRoute =
  userDashboardRouteGroup.route('notification-preferences');

export const userDashboardAccountSettingsRoute =
  userDashboardRouteGroup.route('account-settings');

export const userDashboardPaymentMethodsAddCardRoute =
  userDashboardRouteGroup.route('payment-methods/add-card');

export const userDashboardApplicationHistoryRoute =
  userDashboardRouteGroup.route('application-history');

export const userDashboardApplicationSummaryRoute =
  userDashboardRouteGroup.route('application-summary/:applicationId');
